<div class="overlay" (click)="toggleModal()"></div>
<div class="container-fluid d-flex flex-column g-0 m-0">
  <div class="row g-0 m-0 p-4 justify-content-start borderb top-position">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title"
        >{{ "ADD" | translate }}
        {{ "DEVICESETUP_METERMODEL" | translate }}</span
      >
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon
        class="exit"
        role="button"
        src="assets/device/exit.svg"
        alt="Exit"
      ></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 d-flex middle">
    <form #crudform="ngForm" (ngSubmit)="onSubmit()">
      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="name">{{
            "DEVICESETUP_FIRMWAREVERSION" | translate
          }}*</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="firmwareVersion"
            [(ngModel)]="data.firmwareVersion"
            name="firmwareVersion"
            #firmwareVersion="ngModel"
            type="text"
            required
            [disabled]="isEditMode"
          />
          <div
            *ngIf="crudform.submitted && firmwareVersion.invalid"
            class="validation-error ps-2 pt-2"
          >
            {{ "DEVICESETUP_FIRMWAREVERSION" | translate }}
            {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
          <div
            *ngIf="firmwareVersion.errors?.['required'] && !crudform.submitted"
            class="validation-instruction ps-2 pt-2"
          >
            {{ "SETTINGS_METERMODELDESC_FIRMWARE" | translate }}
          </div>
          <div
            *ngIf="firmwareVersion.errors?.['pattern'] && !crudform.submitted"
            class="validation-error ps-2 pt-2"
          >
            {{ "SPECIALCARACTERSERROR" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 align-items-center">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="firmwareFileName">
            {{ "DEVICESETUP_FIRMWAREIMAGE" | translate }}
          </label>
        </div>

        <div class="col-md-5 d-flex flex-column justify-content-start form-input">
          <input
            #firmwareImage
            id="firmwareImage"
            name="firmwareImage"
            type="file"
            (change)="onFileSelected($event)"
            accept=".bin, .hex"
            style="display: none;"
          />
          <input
            id="firmwareFileName"
            name="firmwareFileName"
            type="text"
            [value]="fileParameter?.fileName || data.firmwareImage || ''"
            readonly
            disabled
          />
        </div>

        <div class="col-md-2 d-flex justify-content-md-center">
          @if (authService.isAuthorized([PermissionEnum.Device_firmware_update]) && (!isEditMode || !data.firmwareImage)) {
            <div class="button-wrapper-gray">
              <div class="button" title="{{ 'UPLOAD' | translate }}" (click)="firmwareImage.click()">
                <svg-icon alt="UPLOAD" class="upload-icon" src="assets/settings/upload-arrow.svg"></svg-icon>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="firmwareIdentifier">
            {{ "DEVICESETUP_FIRMWAREIDENTIFIER" | translate }}
          </label>
        </div>

        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <input
            id="firmwareIdentifier"
            [(ngModel)]="data.firmwareIdentifier"
            name="firmwareIdentifier"
            #firmwareIdentifier="ngModel"
            type="text"
            [disabled]="(!this.fileParameter && !data.firmwareImage) || (isEditMode && !!data.firmwareImage)"
          />

          <div *ngIf="firmwareIdentifierMissing"
            class="validation-instruction ps-2 pt-2">
            {{ "SETTINGS_METERMODELDESC_FIRMWAREID" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="model">{{
            "DEVICESETUP_METERMODEL" | translate
          }}*</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="model"
            [(ngModel)]="data.model"
            name="model"
            #model="ngModel"
            type="text"
            required
            [disabled]="isEditMode"
          />
          <div
            *ngIf="crudform.submitted && model.invalid"
            class="validation-error ps-2 pt-2"
          >
            {{ "DEVICESETUP_METERMODEL" | translate }}
            {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
          <div
            *ngIf="model.errors?.['required'] && !crudform.submitted"
            class="validation-instruction ps-2 pt-2"
          >
            {{ "SETTINGS_METERMODELDESC_MODEL" | translate }}
          </div>
          <div
            *ngIf="model.errors?.['pattern'] && !crudform.submitted"
            class="validation-error ps-2 pt-2"
          >
            {{ "SPECIALCARACTERSERROR" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="model">{{
            "DEVICESETUP_METERMAKE" | translate
          }}*</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <select
            id="meterMakeId"
            [(ngModel)]="data.meterMake"
            name="meterMakeId"
            #meterMakeId="ngModel"
            type="text"
            required
            [disabled]="isEditMode"
          >
            <option *ngFor="let item of metermakes" [ngValue]="item.value">
              {{ item.name }}
            </option>
          </select>
          <div
            *ngIf="crudform.submitted && model.invalid"
            class="validation-error ps-2 pt-2"
          >
            {{ "DEVICESETUP_METERMAKE" | translate }}
            {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
          <div
            *ngIf="!model.valid && !crudform.submitted"
            class="validation-instruction ps-2 pt-2"
          >
            {{ "SETTINGS_METERMODELDESC_METERMAKE" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="disconnectControlModesId"
            >{{ "DEVICESETUP_DISCONNECT_CONTROL_MODE" | translate }}*</label
          >
        </div>
        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <select
            id="disconnectControlModesId"
            [(ngModel)]="data.disconnectControlMode"
            #disconnectControlModesId="ngModel"
            name="disconnectControlModesId"
            required
          >
            <option *ngFor="let item of disconnectControlModes" [ngValue]="item.value">
              {{ item.name }}
            </option>
          </select>
          @if (crudform.submitted && disconnectControlModesId.invalid) {
            <div class="validation-error">
              {{ "DEVICESETUP_DISCONNECT_CONTROL_MODE" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          } @else if (!disconnectControlModesId.valid) {
            <div class="validation-instruction">
              {{ "DEVICESETUP_DISCONNECT_CONTROL_MODE_DESC" | translate }}
            </div>
          }
          @if (isEditMode) {
            <div class="validation-instruction ps-2 pt-1">
              {{ "METERMODEL_DISCONNECT_CHANGE_RELAY_HINT" | translate }}
            </div>
          }
        </div>
      </div>


      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="meterPhase"
          >{{ "DEVICESETUP_METERPHASE" | translate }}*</label
          >
        </div>
        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <select
            id="meterPhase"
            [(ngModel)]="data.meterPhase"
            #meterPhase="ngModel"
            name="meterPhase"
            required
          >
            <option *ngFor="let item of meterPhaseDictionary" [ngValue]="item">
              {{ item }}
            </option>
          </select>
          @if (crudform.submitted && meterPhase.invalid) {
            <div class="validation-error">
              {{ "DEVICESETUP_METERPHASE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          } @else if (!meterPhase.valid) {
            <div class="validation-instruction">
              {{ "MODELSETUP_METERPHASEDESC" | translate }}
            </div>
          }
        </div>
      </div>


      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="code">{{ "CODE" | translate }}*</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="code"
            [(ngModel)]="data.code"
            name="code"
            #code="ngModel"
            type="text"
            pattern="\d{6}"
            required
          />
          <div
            *ngIf="crudform.submitted && code.invalid"
            class="validation-error ps-2 pt-2"
          >
            {{ "CODE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
          @if (!crudform.submitted && code.errors?.["pattern"]) {
            <div class="validation-error">
              {{ "SETTIGNS_REGION_CODE_ERROR" | translate }}
            </div>
          } @else if (!code.valid) {
            <div class="validation-instruction">
              {{ "SETTINGS_AREADESC_CODE" | translate }}
            </div>
          }
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="meterInterface"
            >{{ "DEVICESETUP_INTERFACE" | translate }}*</label
          >
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <select
            id="meterInterface"
            [(ngModel)]="data.interface"
            #meterInterface="ngModel"
            name="meterInterface"
            required
          >
            <option
              *ngFor="let iface of meterInterfaceDictionary"
              [ngValue]="iface"
            >
              {{ iface }}
            </option>
          </select>
          @if (crudform.submitted && meterInterface.invalid) {
            <div class="validation-error">
              {{ "DEVICESETUP_INTERFACE" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          } @else if (!meterInterface.valid) {
            <div class="validation-instruction">
              {{ "DEVICESETUP_INTERFACEDESC" | translate }}
            </div>
          }
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="autentificationType"
            >{{ "DEVICESETUP_AUTHTYPE" | translate }}*</label
          >
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <select
            id="autentificationType"
            [(ngModel)]="data.authorizationLevel"
            #autentificationType="ngModel"
            name="autentificationType"
            required
          >
            <option
              *ngFor="let authType of autentificationTypeDictionary"
              [ngValue]="authType"
            >
              {{ authType }}
            </option>
          </select>
          @if (crudform.submitted && autentificationType.invalid) {
            <div class="validation-error">
              {{ "DEVICESETUP_AUTHTYPE" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          } @else if (!autentificationType.valid) {
            <div class="validation-instruction">
              {{ "DEVICESETUP_AUTHTYPEDESC" | translate }}
            </div>
          }
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="name">{{
              "DEVICESETUP_SYSTITLE" | translate
            }}</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="clientSystemTitle"
            [(ngModel)]="data.systemTitle"
            name="systemTitle"
            #systemTitle="ngModel"
            type="text"
          />
          <div class="validation-instruction ps-2 pt-2">
            {{ "SETTINGS_METERMODELDESC_SYSTITLE" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="clientAddress"
            >{{ "DEVICESETUP_CLIENTADDRESS" | translate }}*</label
          >
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="clientAddress"
            [(ngModel)]="data.clientAddress"
            #clientAddress="ngModel"
            name="clientAddress"
            type="number"
            min="0"
            max="127"
            required
          />
          @if (clientAddress.errors?.["min"] || clientAddress.errors?.["max"]) {
            <div class="validation-error">
              {{ "DEVICESETUP_CLIENTADDRESS" | translate }}
              {{ "DEVICESETUP_CLIENTADDRESSERROR" | translate }}
            </div>
          } @else if (crudform.submitted && clientAddress.invalid) {
            <div class="validation-error">
              {{ "DEVICESETUP_CLIENTADDRESS" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          } @else if (!clientAddress.valid) {
            <div class="validation-instruction">
              {{ "DEVICESETUP_CLIENTADDRESSDESC" | translate }}
            </div>
          }
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="security"
            >{{ "DEVICESETUP_SECURITY" | translate }}*</label
          >
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <select
            id="security"
            [(ngModel)]="data.security"
            #security="ngModel"
            name="security"
            required
          >
            <option
              *ngFor="let security of securityDictionary"
              [value]="security"
            >
              {{ security }}
            </option>
          </select>
          @if (crudform.submitted && security.invalid) {
            <div class="validation-error">
              {{ "DEVICESETUP_SECURITY" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          } @else if (!security.valid) {
            <div class="validation-instruction">
              {{ "DEVICESETUP_SECURITYDESC" | translate }}
            </div>
          }
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="model">{{
              "DEVICESETUP_SMSWAKEMSG" | translate
            }}</label>
        </div>
        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <input
            id="smswakemsg"
            [(ngModel)]="data.smsWakeMessage"
            name="smswakemsg"
            #model="ngModel"
            type="text"
          />
          <div class="validation-instruction ps-2 pt-2">
            {{ "SETTINGS_SMSWAKEMSGDESC_MODEL" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="model">{{
              "DEVICESETUP_SMSWAKETIMEOUT" | translate
            }}</label>
        </div>
        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <input
            id="smswaketimeout"
            [(ngModel)]="data.smsWakeTimeout"
            name="smswaketimeout"
            #model="ngModel"
            type="number"
          />
          <div class="validation-instruction ps-2 pt-2">
            {{ "SETTINGS_SMSWAKETIME_MODEL" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="model">{{
              "DEVICESETUP_SMSRETRYTIMEOUT" | translate
            }}</label>
        </div>
        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <input
            id="smsretrytimeout"
            [(ngModel)]="data.smsRetryTimeout"
            name="smsretrytimeout"
            #model="ngModel"
            type="number"
          />
          <div class="validation-instruction ps-2 pt-2">
            {{ "SETTINGS_SMSRETRYTIME_MODEL" | translate }}
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="blockRequestDelayMs">{{
              "MODELSETUP_BLOCKREQUESTDELAY" | translate
            }}</label>
        </div>
        <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
          <input
            id="blockRequestDelayMs"
            [(ngModel)]="data.blockRequestDelayMs"
            name="blockRequestDelayMs"
            type="number"
            min="0"
          />
          <div class="validation-instruction ps-2 pt-2">
            {{ "MODELSETUP_BLOCKREQUESTDELAYDESC" | translate }}
          </div>
        </div>
      </div>

      @if (selectedMeterModel) {
        <div class="row g-0 m-0 pt-4 pb-3 d-flex justify-content-start">
          <div class="col-md-5 d-flex justify-content-start">
            <label class="item-name" for="creationTime">{{
              "CREATEDTIME" | translate
            }}</label>
          </div>
          <div class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input">
            <input
              id="creationTime"
              name="creationTime"
              type="text"
              [value]="creationDate | date: 'dd MMM yyyy HH:mm'"
              disabled
            />
          </div>
        </div>
      }
    </form>
  </div>
  <div class="row g-0 m-0 p-3 justify-content-between bordert bottom-position">
    <div
      class="col-md-9 p-2 d-flex justify-content-start"
      (click)="toggleModal()"
    >
      <button
        type="button"
        class="crud-cancel-button pt-2 pb-2 ps-4 pe-4 rounded"
      >
        {{ "CANCEL" | translate }}
      </button>
    </div>
    <div
      class="col-md-3 p-2 d-flex justify-content-end align-items-center rounded ms-auto"
    >
      <button
        class="crud-add-button pt-2 pb-2 ps-4 pe-4 rounded"
        (click)="onSubmit()"
        [disabled]="crudform.invalid || firmwareIdentifierMissing"
      >
        {{ "SAVE" | translate }}
      </button>
    </div>
  </div>
</div>

@if (isDisconnectConfirmOpen) {
  <app-confirm-dialog
    titleKey="METERMODEL_DISCONNECT_CHANGE_TITLE"
    question="METERMODEL_DISCONNECT_CHANGE_CONFIRM"
    (confirm)="confirmDisconnectChange()"
    (cancel)="cancelDisconnectChange()"
  ></app-confirm-dialog>
}
